<template>
  <popup-modal ref="popup">
    <div class="myicon-div">
      <span class="myicon fa-solid fa-circle-question"></span>
    </div>
    <span class="msg-title">{{ title }}</span>
    <div class="msg-txt">
      <div class="message" v-html="message"></div>
    </div>
    <div class="btns">
      <span class="btn btn-primary" ref="okbtn" @click="_confirm">{{
        okButton
      }}</span>
      <button class="btn btn-danger" @click="_cancel">
        {{ cancelButton }}
      </button>
    </div>
  </popup-modal>
</template>

<script>
import PopupModal from "./PopupModal.vue";

export default {
  name: "ConfirmDialogue",

  components: { PopupModal },

  data: () => ({
    // Parameters that change depending on the type of dialogue
    title: undefined,
    message: undefined, // Main text content
    okButton: undefined, // Text for confirm button; leave it empty because we don't know what we're using it for
    cancelButton: "Close", // text for cancel button

    // Private variables
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),

  methods: {
    show(opts = {}) {
      this.title = opts.title;
      this.message = opts.message;
      this.okButton = opts.okButton;
      if (opts.cancelButton) {
        this.cancelButton = opts.cancelButton;
      }
      // Once we set our config, we tell the popup modal to open
      this.$refs.popup.open();

      setTimeout(() => {
        this.$refs.okbtn.focus();
      }, 150);
      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },

    _confirm() {
      this.$refs.popup.close();
      this.resolvePromise(true);
    },

    _cancel() {
      this.$refs.popup.close();
      this.resolvePromise(false);
      // Or you can throw an error
      // this.rejectPromise(new Error('User cancelled the dialogue'))
    },
  },
};
</script>

<style scoped>
.btns {
  display: block;
  text-align: right;
  justify-content: right;
}
.btns .btn {
  margin-left: 5px;
  padding: 5px;
  font-size: 14px;
}

.myicon {
  position: relative;
  font-size: 30px;
  margin-right: 15px;
  top: 5px;
}
.fa-circle-question {
  color: #255acc;
}

.msg-title {
  font-size: 22px;
  font-weight: bold;
}
.msg-txt {
  position: relative;
  display: block;
  margin-top: 6px;
  margin-bottom: 6px;
}

.myicon-div {
  position: relative;
  top: -2px;
  display: inline-block;
}
.message {
  position: relative;
  display: inline;
  text-align: left;
  left: 5px;
  width: fit-content;
  height: fit-content;
}
</style>
